import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { FormattedMessage } from 'react-intl';
const computerCommandMenuSkillDetailsOpenedEvent = EVENT_PAYLOAD;
export function ComputerCommandMenuSkillDetailsAction({ item, onSkillDetailsOpen, }) {
    // Featured rows can carry a skill action, but only custom skills have details.
    if (item.type !== 'skill' || !onSkillDetailsOpen)
        return null;
    const skill = item.action.selectableSkill;
    if (skill.built_in)
        return null;
    return (_jsx(Button, { variant: "secondary", size: "small", onClick: () => onSkillDetailsOpen(skill), track: computerCommandMenuSkillDetailsOpenedEvent({
            name: 'computer command menu skill details opened',
            data: { skillUUID: skill.id, skillScope: skill.scope },
        }), children: _jsx(FormattedMessage, { defaultMessage: "More info", description: "Button label for opening details for a skill from the Computer command menu", id: "da0766d75b" }) }));
}
//# sourceMappingURL=ComputerCommandMenuSkillDetailsAction.js.map